// eslint-disable @typescript-eslint/no-unnecessary-condition

import type { TSuccessResponse } from "@sphtech/web2-core/ssr";
import { useRouteLoaderData } from "react-router";

import type { BFFResponseType } from "../types/bff";
import type {
  ArticlePageResponse,
  AuthorPageResponse,
  EventsPageResponse,
  HomePageResponse,
  KeywordsPageResponse,
  ListingPageResponse,
  RegionalPageResponse,
  VideoPageResponse,
} from "../types/response";

// routeId defined in routes.ts
type RouteId =
  | "sectionPage"
  | "articlePage"
  | "authorPage"
  | "keywordPage"
  | "videoPage"
  | "eventsPage"
  | "regionalPage"
  | "homePage";

type RoutePayloadMap = {
  sectionPage: ListingPageResponse;
  articlePage: ArticlePageResponse;
  authorPage: AuthorPageResponse;
  keywordPage: KeywordsPageResponse;
  videoPage: VideoPageResponse;
  eventsPage: EventsPageResponse;
  regionalPage: RegionalPageResponse;
  homePage: HomePageResponse;
};

/**
 * @description use this function to get route loader data with strong type
 */
export function useRouteResponse<T extends RouteId>(
  routeId: T,
): RoutePayloadMap[T] {
  const loaderData =
    useRouteLoaderData<TSuccessResponse<BFFResponseType<RoutePayloadMap[T]>>>(
      routeId,
    );
  return loaderData?.payload.response || ({} as RoutePayloadMap[T]);
}

export const parsePayload = <TPayload extends object = object>(
  loaderData: unknown,
) => {
  const payload = (loaderData as TSuccessResponse<BFFResponseType<TPayload>>)
    .payload;
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  return payload !== undefined ? payload.response : ({} as TPayload);
};
